export const ClassesActionTypes = {
    SET_CURRENT_CLASSES: 'SET_CURRENT_CLASSES',
    REMOVE_CURRENT_CLASSES: 'REMOVE_CURRENT_CLASSES'
}